import { css } from "@emotion/react";
import { css as className } from "@emotion/css";
import { WHITE } from "@snapchat/snap-design-system/es/constants/colors";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const sideNavigationStyle = css`
    padding: ${Spacing.MD}px;
    width: 276px;
    display: flex;
    flex-direction: column;
    background-color: ${WHITE};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    height: calc(100vh - 56px);
    overflow-y: scroll;

    .sds-side-divider-item {
        margin-top: auto;
    }
    ::-webkit-scrollbar {
        display: none;
    }
    scrollbar-width: none;

    a:first-child {
        span {
            padding-left: 0;
        }
    }

    .sds-side-nav-group-item {
        .sds-side-nav-link-item {
            padding-left: ${Spacing.LG}px;
        }
    }
`;

export const selectedListItemClassName = className`
    font-weight: 600 !important;
    font-size: 16px;
    line-height: 28px;
    border: none;
    padding: 0 6px;
    :hover {
        padding: 0 6px;
    }
`;

export const listItemClassName = className`
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    padding: 0 6px;
    :hover {
        background: rgba(0,0,0,.05);
        text-decoration: none;
        border: none;
        padding: 0 6px;
    }
`;

export const sectionStyle = css`
    font-size: 16px;
`;

export const groupStyle = css`
    font-size: 16px;
    color: ${Colors.Black.V200};
    line-height: 28px;
    padding: ${Spacing["1XS"]}px;
    margin: ${Spacing["1XS"]}px 0;

    :hover {
        background: rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        text-decoration: none;
        border: none;
        cursor: pointer;
    }
`;
